<template>
  <div>
    <dropdown-menu
      v-model="show"
      interactive
      :right="dropdownMenuRight"
      class="datatable-dropdowns"
    >
      <button class="toggle text-nowrap">
        {{ label }}
        <span class="toggle-suffix-label" v-if="datesLabel">
          {{ datesLabel }}
        </span>
      </button>
      <div slot="dropdown">
        <RangeDatePicker
          :ref="`range-date-picker-${_uid}`"
          v-model="dates"
          language="en"
          colorToday="#007bff"
          colorActive="#d6eaff"
          colorSelected="#007bff"
        />
        <div class="action-buttons">
          <button class="reset-button" @click="onReset">Reestablecer</button>
          <button class="confirm-button" @click="onConfirm">Confirmar</button>
        </div>
      </div>
    </dropdown-menu>
  </div>
</template>

<script>
// Components
import DropdownMenu from '@innologica/vue-dropdown-menu'
import RangeDatePicker from 'vue-easy-range-date-picker'

// Utils
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  props: {
    label: String
  },
  components: {
    RangeDatePicker,
    DropdownMenu
  },
  data () {
    return {
      show: false,
      dates: {},
      datesLabel: '',
      dropdownMenuRight: false
    }
  },
  methods: {
    onOpenDatePickerDropdown () {
      this.$nextTick(() => {
        const datatableWrapper = document.querySelector('.datatable-wrapper')
        const datatableProps = datatableWrapper.getBoundingClientRect()

        const filterButton = this.$refs[`range-date-picker-${this._uid}`].$el.closest('div.datatable-filter-item')

        if (datatableProps.width < filterButton.offsetLeft + 641) {
          this.dropdownMenuRight = true
        } else {
          this.dropdownMenuRight = false
        }
      })
    },
    onReset () {
      this.$refs[`range-date-picker-${this._uid}`].certainDays = []
      this.$refs[`range-date-picker-${this._uid}`].hoverDay = null
      this.dates = {}
      this.datesLabel = ''
      this.$emit('change', [])
    },
    onConfirm () {
      let { start, end } = this.dates
      let from = start ? moment(start).set('hour', 0).set('minute', 0).set('second', 0).toISOString() : null
      let to = end ? moment(end).set('hour', 23).set('minute', 59).set('second', 59).toISOString() : null
      const dates = [
        { value: from },
        { value: to }
      ]
      this.datesLabel = moment(start).format('DD / MM') + ' - ' + moment(end).format('DD / MM')
      this.$emit('change', dates)
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.onOpenDatePickerDropdown()
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .range-date-picker-wrapper
    position: absolute
    margin-top: .8rem
    z-index: 5
    width: 641px
  button.toggle
    display: flex
    gap: 10px
    background-color: #e9ecef
    border: 0
    padding: .5rem .8rem
    border-radius: 8px
    .toggle-suffix-label
      background-color: white
      display: flex
      justify-content: center
      align-items: center
      padding: 0 10px
      border-radius: 8px
  .dropdown-menu
    border: none !important
  .action-buttons
    background-color: white
    width: 100%
    box-shadow: 0 2px 8px 0 rgba(#000, .10)
    padding: .8rem 0
    display: flex
    > button
      width: 50%
      text-transform: uppercase
      background-color: white
      border: none
      outline: none
    > .confirm-button
      color: #007bff
</style>
